import { gql } from 'graphql-request';

export const PROCESS_VERSION_FIELDS = gql`
  fragment ProcessVersionFields on ProcessVersionDto {
    processVersionId
    processId
    organizationId
    version
    bumpType
    createdByUser {
      userId
      email
      firstName
      lastName
    }
    changeDescription
    createdAt
  }
`;

export const getProcessVersions = gql`
  query getProcessVersions($processId: String!) {
    getProcessVersions(processId: $processId) {
      ...ProcessVersionFields
    }
  }
  ${PROCESS_VERSION_FIELDS}
`;

export const getLatestProcessVersion = gql`
  query getLatestProcessVersion($processId: String!) {
    getLatestProcessVersion(processId: $processId) {
      ...ProcessVersionFields
    }
  }
  ${PROCESS_VERSION_FIELDS}
`;


const ProcessVersionGraphQL = {
  queries: {
    getProcessVersions,
    getLatestProcessVersion,
  },
};

export default ProcessVersionGraphQL;
